module.exports = __webpack_public_path__ + "static/img/news4_1.0ba6d07.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/news4_1.jpg
// module id = L3cs
// module chunks = 1